// extracted by mini-css-extract-plugin
export default {"mainSec":"styles_mainSec__w5qHo","tabContainer":"styles_tabContainer__F+cUz","tab":"styles_tab__ZFpGv","activeTab":"styles_activeTab__jUDUG"};